import {Box, Dialog, DialogContent, Typography} from "@mui/material";
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import SteddiButton from "../../General/SteddiButton";
import Grid2 from "@mui/material/Unstable_Grid2";
import useAppState from "../../../stores/appStateStore";

export default NiceModal.create(() => {
  const redirectBrand = useAppState((state) => state.redirectBrand)
  const modal = useModal();

  function onClose() {
    modal.remove()
  }

  function getBrandUrl () {
    switch(redirectBrand){
      case 1: return "https://minside.fjordkraft.no/tjenester/forutsigbar"
      case 2: return "https://minside.trondelagkraft.no/tjenester/forutsigbar"
      default: return "https://www.steddi.no/"
    }
  }

  function goToBrandUrl(){
    window.location.href = getBrandUrl();
  }

  return(
    <Dialog open={modal.visible} onClose={onClose} style={{overflowY: "auto"}} maxWidth="xs">
      <DialogContent sx={{margin: 0}}>
        <Box my={5}>
          <Grid2 container spacing={3}>
            <Grid2 xs={12}>
              <Typography>Er du sikker på at du ønsker å avbryte? Da vil alle endringene dine gå tapt.</Typography>
            </Grid2>
            <Grid2 xs={12}><SteddiButton fullWidth color="contrast" onClick={onClose}>Nei, jeg ønsker å fortsette</SteddiButton></Grid2>
            <Grid2 xs={12}><SteddiButton fullWidth onClick={goToBrandUrl}>Ja, jeg ønsker å avbryte</SteddiButton></Grid2>
          </Grid2>
        </Box>
      </DialogContent>
    </Dialog>
  )
})